import * as serviceContext from './serviceContext';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function addMarquee(marqueeData) {
    try {
        const response = await serviceContext.post("notification/marquee", JSON.stringify(marqueeData), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getMarquee() {
    try {
        const response = await serviceContext.get("marketprovider/marquee", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};